import React from 'react';
import { Card, Grid, Typography } from '@mui/material';

export const QuotePresetErrorPanel = () => {
  return (
    <Grid
      container
      sx={{
        justifyContent: 'center',
        paddingBottom: '10px',
        paddingTop: { xs: 0, sm: '50px' },
      }}
    >
      <Grid size={{ xs: 10, sm: 8 }} sx={{ minHeight: 200 }}>
        <Card
          elevation={0}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '200px',
            backgroundColor: ({ palette }) => `${palette.text.main}10`,
            boxShadow: ({ palette }) => `0px 4px 20px -8px ${palette.background.main}25`,
            borderRadius: '8px',
          }}
        >
          <Typography
            variant='body1'
            sx={{
              mt: '10px',
            }}
          >
            Your URL Preset is invalid, please contact your Broker or LIO support for assistance.
          </Typography>
        </Card>
      </Grid>
    </Grid>
  );
};
